import { useSelector, useDispatch } from 'react-redux';
import { refreshApiData, updateUsageData, clearApiError } from 'src/store/Api';

export const useApiData = () => {
  const dispatch = useDispatch();
  const apiState = useSelector((state: any) => state.api);

  const refreshData = () => {
    dispatch(refreshApiData());
  };

  const updateUsage = (days: number) => {
    dispatch(updateUsageData(days));
  };

  const clearError = () => {
    dispatch(clearApiError());
  };

  return {
    // Data
    apiKeyData: apiState.apiKeyData,
    usageData: apiState.usageData,

    // Loading states
    loading: apiState.loading,
    refreshing: apiState.refreshing,
    updatingUsage: apiState.updatingUsage,

    // Error state
    error: apiState.error,

    // Actions
    refreshData,
    updateUsage,
    clearError,
  };
};
